import { ApplicationController, useDebounce } from "stimulus-use";

export default class extends ApplicationController {
  // static debounces = [ "click" ];
  static targets = [ "click" ];

  connect() {
    // useDebounce(this, { wait: 150 });
  }

  click(event) {
    // console.log("Click Event: ", event.target);
    if (event.target.closest("a, form")) return;
    this.clickTargets.filter(target => target !== event.target)
                     .forEach(target => target.click());
  }
}
